import { render, staticRenderFns } from "./PelletizingEnergyCostList.vue?vue&type=template&id=4a104720&"
import script from "./PelletizingEnergyCostList.vue?vue&type=script&lang=js&"
export * from "./PelletizingEnergyCostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports